import { Component, OnInit, Inject,EventEmitter } from '@angular/core';
import { Validators,FormBuilder, FormGroup, FormArray, FormControl,NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from "@ngrx/store";
import { Client, Filedescriptions, ClientFileInfoModel, Filetype, ClientState,ClientFileState, SFTPInfo } from '@core/services/client/client.model';
import { ClientService } from '@core/services/client/client.service';
import { AuthService } from '@core/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-client-file-info-edit',
  templateUrl: './client-file-info-edit.component.html',
  styleUrls: ['./client-file-info-edit.component.scss']
})
export class ClientFileInfoEditComponent implements OnInit {
  filetypechange: EventEmitter<boolean> = new EventEmitter<boolean>();
  clientFileForm: FormGroup;  
  Id:number; 
  clientid: number;
  client:Client;
  selectedfileinfo:any; 
  selectedFileTypeData: any;
  filetypes: Filetype[];  
  sftps: SFTPInfo[];
  selectedSftp: SFTPInfo[];
  selectedData:any;
  clientfiles: string[][];
  constructor(
    private fb: FormBuilder,
    private store: Store<ClientFileState>, 
    private toastrService: ToastrService,   
    private auth:AuthService,
    private clientService:ClientService,     
    public dialogRef: MatDialogRef<ClientFileInfoEditComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any    
  )
   {
    this.clientFileForm = new FormGroup({
        id:  new FormControl(0),
        description:new FormControl(''),
        filename:new FormControl(''),
        filetypeid: new FormControl(1),
        sftpinfoid: new FormControl(1),
        fileextension:  new FormControl(''),
        sftpsourcefolder:new FormControl(''),   
        sftpdestinationfolder: new FormControl(''),   
        minutesbetweenchecks: new FormControl('', [Validators.min(0)]),
        minutestowait: new FormControl('', [Validators.min(0)]),
        filenameexpression: new FormControl(''),
        isactive: new FormControl(true),
        disableduplicatefilenamecheck: new FormControl(false),
        bypassemptyreturnfile: new FormControl(false),
        rejectedalertinpercent: new FormControl(false),
        rejectedalertthreshold: new FormControl('', [Validators.min(0)]),
        clientfileid: new FormControl(''),
      });    
   }

  ngOnInit() {  
    setTimeout(() => {
        this.clientService.Getfiletype().subscribe(FileType => 
           { this.filetypes = FileType as Filetype[] });   
        this.clientService.GetSFTPInfo().subscribe(sftp =>
            {this.sftps = sftp as SFTPInfo[];
             if(this.data.clientfile != null) 
             {
                this.selectedSftp = this.sftps.filter(x => x.id == this.data.clientfile.value.sftpinfoid);
             }         
            });
        this.clientService.GetClientInputFileInfos(this.data.clientid).subscribe(files => 
          { this.clientfiles = files as string[][] });  
     }, 800);

    if(this.data.clientfile==null)
    {
        this.Id =-1;
        this.clientid = this.data.clientid;
    }
    else{
        this.Id= this.data.clientfile.value.id;
        this.clientid = this.data.clientid;
        this.clientFileForm.patchValue({...this.data.clientfile.value }); 
        this.clientService.retrieveClientById(this.clientid).subscribe(data =>
            this.client = data);
        console.log('start',this.data.clientfile.controls);
    } 
    this.UI_ValidatorsSetting ();     
  }

  filetypeselected(event) {
    let target = event.source.selected._element.nativeElement;
    this.selectedFileTypeData = {
      value: event.value,
      text: target.innerText.trim()
    };
   
    if (event.value === 2 || this.clientFileForm.get("filetypeid").value===2) {
      this.filetypechange.emit(true);
    }

    var rejectedalertthreshold = this.clientFileForm.get('rejectedalertthreshold'); 

    if(event.value ===1)
    {
      rejectedalertthreshold.setValidators([Validators.required]);
      rejectedalertthreshold.updateValueAndValidity({ emitEvent: true });
    }
    else{
      rejectedalertthreshold.setValidators([Validators.nullValidator]);
      rejectedalertthreshold.updateValueAndValidity({ emitEvent: true });
    }   
  
  }

  onClose(): void {    
    this.dialogRef.close();
  }  

  createOrUpdateClientFileInfo(form: NgForm) {
    this.formControl_DescriptionValueChanged();
    if(this.clientFileForm.valid)
    {
        const newOrUpdatedFileInfo: ClientFileInfoModel = {
            id: this.Id,
            description: this.clientFileForm.get("description").value,
            filename: this.clientFileForm.get("filename").value,
            fileextension: this.clientFileForm.get("fileextension").value,
            sftpsourcefolder: this.clientFileForm.get("sftpsourcefolder").value,
            sftpdestinationfolder:this.clientFileForm.get("sftpdestinationfolder").value,
            minutestowait: this.clientFileForm.get("minutestowait").value,
            minutesbetweenchecks:  this.clientFileForm.get("minutesbetweenchecks").value, 
            filenameexpression: this.clientFileForm.get("filenameexpression").value,
            disableduplicatefilenamecheck: this.clientFileForm.get("disableduplicatefilenamecheck").value, 
           // bypassemptyreturnfile: this.clientFileForm.get("bypassemptyreturnfile").value,
            sftpinfoid: this.clientFileForm.get("sftpinfoid").value, 
            clientinfoId:this.clientid,  
            filetypeid:this.clientFileForm.get("filetypeid").value, 
           // isactive: this.clientFileForm.get("isactive").value, 
            //rejectedalertinpercent: this.clientFileForm.get("rejectedalertinpercent").value,  
           // rejectedalertthreshold: this.clientFileForm.get("rejectedalertthreshold").value, 
            isdeleted: false, 
            isenabled: false,       
            lastupdatedby:this.auth.currentUserValue.username,
            //parentclientfileinfoid: this.clientFileForm.get("clientfileid").value,
           };    
          
        this.clientService.createOrUpdateClientFileInfo(newOrUpdatedFileInfo).subscribe(data =>
            {
                    this.dialogRef.close(data);
                    form.resetForm();
            });       
        
    }
    else{
      this.toastrService.error("This page has validation error, Please check each field.", "Validation Error")
    }
        
}

ChoseAllSFTP(event) {
  if (event.checked) {
    this.selectedSftp = this.sftps;
  }
  else {
    this.selectedSftp = this.sftps.filter(x => x.id == this.data.clientfile.value.sftpinfoid);
  }
 
}

UI_ValidatorsSetting() {  
    this.formControl_DescriptionValueChanged();
  }

  gettxt_SFTPFolder(): string {
    if (this.clientFileForm.get("filetypeid").value !== 1) {
      return 'SFTP Destination Folder';
    }
    else {
      return 'SFTP Report Destination Folder';
    }
  }

  formControl_DescriptionValueChanged() {   

    const iconfilenameexp = this.clientFileForm.get("filenameexpression");
    const iconSourceFolder = this.clientFileForm.get("sftpsourcefolder");
      if (this.clientFileForm.get('filetypeid').status.toUpperCase() == "VALID") {
        if (this.clientFileForm.get("filetypeid").value !== 1) {
          if (this.clientFileForm.get("filetypeid").value === 2) {     
            iconSourceFolder.disable();
          }
          else {
            iconfilenameexp.setValidators(null);
            iconSourceFolder.setValidators(null);
            iconSourceFolder.enable();
          }
        }
        else {
          iconfilenameexp.setValidators([Validators.required]);
          iconSourceFolder.enable();
          iconSourceFolder.setValidators([Validators.required]);
        }
        iconfilenameexp.updateValueAndValidity({ emitEvent: true });
        iconSourceFolder.updateValueAndValidity({ emitEvent: true });
      }
        this.clientFileForm.get("filetypeid").valueChanges.subscribe(
        (mode: string) => {
          if (this.clientFileForm.get('filetypeid').status.toUpperCase() == "VALID") {
            if (this.clientFileForm.get("filetypeid").value !== 1) {
              if (this.clientFileForm.get("filetypeid").value === 2) { 
                iconfilenameexp.setValidators(null);
                iconSourceFolder.setValidators(null);         
                iconSourceFolder.disable();
              }
              else {
                iconfilenameexp.setValidators(null);
                iconSourceFolder.setValidators(null);
                iconSourceFolder.enable();
              }
            }
            else {
              iconfilenameexp.setValidators([Validators.required]);
              iconSourceFolder.enable();
              iconSourceFolder.setValidators([Validators.required]);
            }
            iconfilenameexp.updateValueAndValidity({ emitEvent: true });
            iconSourceFolder.updateValueAndValidity({ emitEvent: true });
          }
        });
    
      var rejectedalertthreshold = this.clientFileForm.get('rejectedalertthreshold');
      this.clientFileForm.get('rejectedalertinpercent').valueChanges.subscribe(
        (mode: string) => {
          if (this.clientFileForm.get('rejectedalertinpercent').value) {
            rejectedalertthreshold.setValue('');
            rejectedalertthreshold.setValidators([Validators.max(100), Validators.min(0)]);
          }
          else {
            rejectedalertthreshold.setValue('');
            rejectedalertthreshold.setValidators([Validators.min(0)]);
          }
          rejectedalertthreshold.updateValueAndValidity({ emitEvent: false });
        }) 
  }

}
